import { useMemo } from 'react';
import apiClient from 'src/api/axiosClient';
import { CanvaDesigns } from '../types/CanvaDesigns';

export function useCanvaApi() {
  return useMemo(
    () => ({
      getCanvaCompanyPortalLink: () => {
        return apiClient.get<{ url: string }>(`canva/authorization-url`);
      },
      connectToCanva: (code: string, state: string) => {
        const params = { code, state };
        return apiClient.get<{ url: string }>(`canva/authorize`, { params });
      },
      disconnectFromCanva: () => {
        return apiClient.delete('canva/authorization');
      },
      getDesigns: async (searchTerm?: string): Promise<{ data: CanvaDesigns }> => {
        const params = searchTerm ? { query: searchTerm } : undefined;
        return apiClient.get('canva/designs', { params });
      },
      getDesign: async (companyId: string, designId: string, name?: string): Promise<{ data: { url: string } }> => {
        const params = { companyId, designId, name };
        return apiClient.get('canva/media', { params });
      },
    }),
    [],
  );
}
